import { useAuth } from '../context/AuthContext';
import useStoreAccessStatus from './useStoreAccessStatus';
import { DEFAULT_PRO_ENTITLEMENTS, isEffectivePro, isFreeOrLapsed } from '../utils/storePlan';

const isAppAdminUser = (user) => {
  const userType = user?.userType || user?.user_type;
  return userType === 1 || userType === '1' || userType === 'AppAdmin' || userType === 'appAdmin';
};

const useStorePlan = (storeId, enabled = true) => {
  const { managementUser } = useAuth();
  const isAppAdmin = isAppAdminUser(managementUser);
  const shouldLoad = enabled && !isAppAdmin;
  const { accessStatus, loading, error, refresh } = useStoreAccessStatus(storeId, shouldLoad);
  const entitlements = isAppAdmin ? DEFAULT_PRO_ENTITLEMENTS : (accessStatus?.entitlements ?? null);

  return {
    accessStatus: isAppAdmin ? { canAccess: true, blockReason: null, entitlements } : accessStatus,
    entitlements,
    isPro: isAppAdmin || isEffectivePro(entitlements),
    isFreeOrLapsed: !isAppAdmin && isFreeOrLapsed(entitlements),
    loading: isAppAdmin ? false : loading,
    error: isAppAdmin ? null : error,
    refresh,
  };
};

export default useStorePlan;
